import React, { Component } from 'react'

import { connect, batch } from 'react-redux';
import { styles } from '../../containers/dockPadStyle'
import { compose } from 'redux';
import { withStyles, Typography, Divider } from '@material-ui/core';


import { withRouter } from 'react-router';
import { getLocationPathName } from '../../selectors/util.selector';
import { DatePicker } from "material-ui-pickers";
import moment, { Moment } from 'moment'
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import { green } from '@material-ui/core/colors';
import { isPrintBoardOpen } from '../../selectors/phaseplan.selector';
import Dialog from '@material-ui/core/Dialog'
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from '@material-ui/core/DialogActions'
import TextField from '@material-ui/core/TextField'

import Button from '@material-ui/core/Button';
import { dialogActions } from '../../actions/dialog.actions';
import { ThunkDispatch } from 'redux-thunk';
import { ClassNameMap } from '@material-ui/core/styles/withStyles';
import { lookaheadActions } from '../../actions/lookahead.actions';
import { alertActions } from '../../actions/alert.actions'
import { getCommitmentDay, getMinCommitmentDate } from '../../selectors/lookahead.selector';
import DayPicker from '../DayPicker';

interface Props {
    isPrintBoardOpen: boolean;
    closeDialogValue: () => void;
    classes: ClassNameMap,
    errorAlert: (message:string) => void;
    sendMRPBoard: (emailText, start, end) => void
}

type State = {
    startDate: number,
    endDate: number,
    emailText: string
}



class PrintBoardDialog extends Component<Props, State> {
    constructor(props:Props) {
        super(props)

        this.state = {
            startDate: moment().valueOf(),
            endDate: moment().add(1,'months').valueOf(),
            emailText: ''
        }
    }


    closeDialog = async () => {
        const { closeDialogValue } = this.props
        closeDialogValue()
    }

    handleStartDateChange = (value: Moment) => {
        const date = value.valueOf()
        this.setState({
            startDate: date
        })
    }

    handleEndDateChange = (value: Moment) => {
        const date = value.valueOf()
        this.setState({
            endDate: date
        })
    }



    onConfirm = () => {
        const { startDate, endDate, emailText } = this.state
        const { closeDialogValue, errorAlert, sendMRPBoard } = this.props
        if(!emailText || emailText.length <= 0) {
            errorAlert("A Email is needed")
        }

        sendMRPBoard(emailText, startDate, endDate)
        


        closeDialogValue()
    }



    onEnter = () => {
        this.setState({
            startDate: moment().valueOf(),
            endDate: moment().add(1, 'months').valueOf(),
        })
    }

    handleTextChange(event) {
        this.setState({
          emailText: event.target.value
        })
    }

    render() {
        const { classes } = this.props;
        const { startDate, endDate } = this.state

        return (
            <Dialog
                maxWidth='sm'
                fullWidth={true}
                open={!!this.props.isPrintBoardOpen}
                onEnter={this.onEnter}
                onBackdropClick={this.closeDialog.bind(this)}
            >
                <DialogContent>
                    <div style={{backgroundColor: ''}} className={classes.DialogFormTitle}>
                        <p className={classes.DialogFormTitleText}>
                            Email Schedule
                        </p>
                    </div>
                    <div>
                        <div className={classes.DialogFormContent} >
                            <TextField
                                margin='dense'
                                id='name'
                                label='Type in E-mail Addresses, separated with comma'
                                type='email'
                                onChange={this.handleTextChange.bind(this)}
                                variant='outlined'
                                fullWidth
                            />
                            <div>
                                <Typography variant="subtitle1">
                                    Choose A Date Range
                                </Typography>
                                <div style={{display: 'flex', justifyContent: 'space-around'}}>
                                    <DatePicker value={moment(startDate)} onChange={this.handleStartDateChange} label="Start Date" />
                                    <DatePicker  value={moment(endDate)} onChange={this.handleEndDateChange} label="End Date" />
                                </div>
                            </div>
                        </div>
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.closeDialog.bind(this)} color="secondary"> Cancel </Button>
                    <Button onClick={this.onConfirm}  color="primary"> Confirm </Button>
                </DialogActions>
            </Dialog>
        )
    }
}

const mapStateToProps = (state:any) => ({
    isPrintBoardOpen: isPrintBoardOpen(state),

});

const mapDispatchToProps = (dispatch: ThunkDispatch<{}, {}, any>) => {

    return {
        closeDialogValue: () => dispatch(dialogActions.closePrintBoardDialog()),
        savePromiseTagsByDates: (startDate:number, endDate:number) => dispatch(lookaheadActions.savePromiseTagsByDates(startDate, endDate)),
        errorAlert: (message:string) => dispatch(alertActions.error(message)),
        sendMRPBoard: (emailText: string, start: number, end: number) => dispatch(lookaheadActions.emailMRPBoard(emailText, start, end))
    }
};


export default compose<React.ComponentClass>(
    withRouter,
    connect(mapStateToProps, mapDispatchToProps),
    withStyles(styles, { withTheme: true }),
)(PrintBoardDialog)


// WEBPACK FOOTER //
// ./src/components/Dialogs/PrintBoardDialog.tsx